import { render, staticRenderFns } from "./ExternalLinkPdfPreview.vue?vue&type=template&id=2ccd2626&scoped=true&"
import script from "./ExternalLinkPdfPreview.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkPdfPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd2626",
  null
  
)

export default component.exports